import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	triggerButton: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	triggerButton: {
		id: 'native-issue-table.common.issue-cells.affected-services.trigger-button',
		defaultMessage: 'See more affected services',
		description: 'Label for trigger button to open a dialog with a list of affected services',
	},
});
export default messages;
